import { render, staticRenderFns } from "./Carrosal.vue?vue&type=template&id=41851cea&"
import script from "./Carrosal.vue?vue&type=script&lang=js&"
export * from "./Carrosal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports